import React, { useEffect, useState } from "react";
import useLatestRequest from "../utils/useLatestRequest";
import { Card, Table, Button, Space, Input } from "antd";
import { FaArrowLeft, FaDownload, FaSearch } from "react-icons/fa";

const TenderOverReport = ({ onBack }) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [reportPeriod, setReportPeriod] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [filters, setfilters] = useState("");
  const [search, setSearch] = useState("");

  const handleFilter = (e) => {
    setfilters(e.target.value);
  };
  useEffect(() => {
    const id = setTimeout(() => {
      setSearch(filters.trim());
    }, 300);
    return () => clearTimeout(id);
  }, [filters]);

  // Search is backend-driven now; API returns filtered rows.

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  useEffect(() => {
    fetchTenderData();
  }, [search]);

  const beginRequest = useLatestRequest();

  const fetchTenderData = async () => {
    const isCurrent = beginRequest();
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.set("isExcel", "false");
      if (search) params.set("search", search);
      const url = `${apiBaseUrl}/inventoryManagement/getTenderOverReport?${params.toString()}`;
      const res = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
      });
      if (!isCurrent()) return;
      if (!res.ok) {
        console.error("Failed to fetch tender report:", res.statusText);
        setData([]);
        return;
      }
      const result = await res.json();
      if (!isCurrent()) return;
      if (result.success) {
        setData(result.data || []);
        setReportPeriod(result.reportPeriod || null);
      } else {
        console.error("Failed to fetch tender report:", result.message);
      }
    } catch (err) {
      if (!isCurrent()) return;
      console.error("Error fetching tender report:", err);
    } finally {
      if (isCurrent()) setLoading(false);
    }
  };

  const handleDownloadExcel = async () => {
    setDownloading(true);
    try {
      const params = new URLSearchParams();
      params.set("isExcel", "true");
      if (search) params.set("search", search);
      const url = `${apiBaseUrl}/inventoryManagement/getTenderOverReport?${params.toString()}`;
      const res = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token ${window.localStorage.getItem("token")}`,
        },
      });
      if (!res.ok) {
        console.error("Failed to download Excel:", res.statusText);
        setDownloading(false);
        return;
      }
      const blob = await res.blob();
      const fileUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = fileUrl;
      a.download = `TenderOver_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(fileUrl);
      document.body.removeChild(a);
    } catch (err) {
      console.error("Error downloading Excel:", err);
    } finally {
      setDownloading(false);
    }
  };

  const fmtDate = (d) => {
    if (!d) return "-";
    try {
      return new Date(d).toLocaleDateString("en-GB");
    } catch {
      return d;
    }
  };

  const columns = [
    {
      title: "Code No.",
      dataIndex: "CodeNo",
      key: "CodeNo",
      width: 100,
      align: "center",
      render: (v) => v || "N/A",
    },
    {
      title: "Location",
      dataIndex: "locations",
      key: "locations",
      width: 300,
      render: (locs) =>
        Array.isArray(locs)
          ? locs.map((l) => l.name).join(", ")
          : locs?.name || "N/A",
    },
    {
      title: "Illu",
      dataIndex: "Illu",
      key: "Illu",
      width: 100,
      render: (illu) => (illu ? String(illu) : "N/A"),
    },
    {
      title: "Owned By",
      dataIndex: "ownedBy",
      key: "ownedBy",
      width: 100,
      render: (o) => o || "N/A",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      width: 140,
      align: "center",
      render: (d) => fmtDate(d),
    },
    {
      title: "Last BDF Date",
      dataIndex: "bdfCreatedAt",
      key: "bdfCreatedAt",
      width: 120,
      align: "center",
      render: (d) => fmtDate(d),
    },
    {
      title: "Removed Date",
      dataIndex: "endDate",
      key: "endDate",
      width: 140,
      align: "center",
      render: (d) => fmtDate(d),
    },
    {
      title: "Last BDF Brand Name",
      dataIndex: "brandName",
      key: "brandName",
      width: 150,
      render: (n) => n || "-",
    },
  ];

  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: 12,
        padding: 20,
        minHeight: "100vh",
      }}
    >
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Space>
              <Button icon={<FaArrowLeft />} onClick={onBack} type="text" />
              Tender Over Report
            </Space>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Space>
                <Input
                  prefix={<FaSearch style={{ color: "#999" }} />}
                  style={{ width: 250 }}
                  type="text"
                  placeholder="Enter CodeNo or Location"
                  value={filters}
                  onChange={handleFilter}
                />
              </Space>
              <Space>
                <Button
                  type="primary"
                  icon={<FaDownload />}
                  loading={downloading}
                  onClick={handleDownloadExcel}
                >
                  Download Excel
                </Button>
              </Space>
            </div>
          </div>
        }
      >
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          rowKey={(r) => r._id || r.CodeNo}
          pagination={false}
          scroll={{ y: 500 }}
          components={components}
          sticky
        />
      </Card>
    </div>
  );
};

export default TenderOverReport;
